import { Component, OnInit, ViewChild } from '@angular/core';

import { PoCheckboxGroupOption, PoModalComponent, PoModalAction } from '@po-ui/ng-components';
import { PoPageLogin, PoPageLoginCustomField, PoPageLoginLiterals } from '@po-ui/ng-templates';
import { AuthService } from 'src/app/shared/service/auth.service';
import { TokenService } from 'src/app/shared/service/token.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  @ViewChild(PoModalComponent, { static: true })
  poModal!: PoModalComponent;
  msgError!: string;
  background!: string;
  contactEmail!: string;
  customField!: PoPageLoginCustomField;
  customLiterals!: PoPageLoginLiterals;
  environment!: string;
  exceededAttempts!: number;
  secondaryLogo!: string;
  languages!: any;
  literals!: string;
  login!: string;
  loginPattern!: string;
  loginError!: string;
  loginErrors!: Array<string>;
  logo!: string;
  passwordError!: string;
  passwordErrors!: Array<string>;
  passwordPattern!: string;
  productName!: string;
  properties!: Array<string>;
  recovery!: string;
  registerUrl!: string;
  support!: string;
  authReturn!: any;
  mfaValue!: any;

  infoLogin!: any;
  infoPassword!: any;
  infoTenant!: any;
  show: boolean = false;

  public readonly propertiesOptions: Array<PoCheckboxGroupOption> = [
    { value: 'hideRememberUser', label: 'Hide remember user' },
    { value: 'loading', label: 'Loading' }
  ];

  constructor(private authService: AuthService, private tokenService: TokenService) {}

  closeModal() {
    this.poModal.close();
  }

  openModal() {
    this.poModal.open();
  }

  addMfaValue(item: any) {
    this.show = true;
    this.authService.getMfa(this.infoLogin, this.infoPassword, this.infoTenant, item.modelLastUpdate);
    this.poModal.close();
    this.show = false;
  }

  ngOnInit() {
    this.restore();
    this.closeModal();
    this.customField.value = this.tokenService.getTenant()?.toString();
  }

  addLoginError() {
    this.loginErrors.push(this.loginError);
    this.loginError = '';
  }

  addPasswordError() {
    this.passwordErrors.push(this.passwordError);
    this.passwordError = '';
  }

  changeLiterals() {
    try {
      this.customLiterals = JSON.parse(this.literals);
    } catch {
      this.customLiterals = {};
    }
  }

  loginSubmit(formData: PoPageLogin) {
    this.show = true;
    this.infoLogin = formData.login;
    this.infoPassword = formData.password;
    this.infoTenant = `${this.customField.value}`;
    this.tokenService.saveTenant(`${this.customField.value}`);
    this.tokenService.saveUsername(formData.login);
    localStorage.removeItem('sellerCode')
    this.verifyMfa(formData);
  }

  verifyMfa(item: any) {
    let trim = item.login.split('@');
    if (trim[1] == 'totvs.com.br') {
      this.openModal();
      this.show = false;
    } else {
      this.authService.postLogin(item.login, item.password, `${this.customField.value}`);
      this.show = false;
    }
  } 

  onChangeCustomProperties() {
    this.customField = Object.assign({}, this.customField);
  }

  restore() {
    this.properties = [];
    this.background = '';
    this.contactEmail = '';
    this.customField = { property: 'tenant', placeholder: 'Informe seu tenant' };
    this.customLiterals = {
      highlightInfo: '',
      welcome: 'Boas-vindas',
      loginErrorPattern: 'Login obrigatório',
      loginHint: 'Caso não possua usuário entre em contato com o suporte',
      loginPlaceholder: 'Usuário',
      passwordErrorPattern: 'Senha obrigatória',
      passwordPlaceholder: 'Senha',
      customFieldErrorPattern: 'Campo customizado inválido',
      customFieldPlaceholder: 'Por favor insira um valor',
      rememberUserHint: 'Esta opção pode ser desabilitada nas configurações do sistema',
      submitLabel: 'Entrar',
      submittedLabel: 'Carregando...',
    };
    this.environment = '';
    this.exceededAttempts = 0;
    this.secondaryLogo = '';
    this.languages = [];
    this.literals = '';
    this.login = '';
    this.loginPattern = '';
    this.loginError = '';
    this.loginErrors = [];
    this.logo = './assets/imgs/logo-totvs-azul-escuro.png';
    this.passwordError = '';
    this.passwordErrors = [];
    this.passwordPattern = '';
    this.passwordError = '';
    this.passwordErrors = [];
    this.productName = 'MINHAS OPERAÇÕES';
    this.recovery = 'https://www.google.com.br/';
    this.registerUrl = '';
    this.support = '';
    localStorage.removeItem('sellerCode')
  }
}
